import { render, staticRenderFns } from "./EventBoothQuestionAddContent.vue?vue&type=template&id=601b4578"
import script from "./EventBoothQuestionAddContent.vue?vue&type=script&lang=js"
export * from "./EventBoothQuestionAddContent.vue?vue&type=script&lang=js"
import style0 from "./EventBoothQuestionAddContent.vue?vue&type=style&index=0&id=601b4578&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports